import {
  fetchDoLogin,
  fetchGetCaptcha,
  fetchDoLogout,
  fetchValidateTokenBSS,
  fetchTermsAndConditions,
  fetchListServices,
  fetchHeadline,
  fetchListProduk,
  fetchCallToAction,
  fetchListWordStyling,
  fetchListDaftarProduk,
  fetchAnnouncement,
} from "@/src/services/api/loginPage";
import { identifyUser, clearUser } from "@/src/lib/monitoring";
import {
  CAPTCHA,
  LOADING_CAPTCHA,
  LOGIN,
  LOADING_LOGIN,
  LOGOUT,
  LOADING_LOGOUT,
  VALIDATE_TOKEN_BSS,
  LOADING_VALIDATE_TOKEN_BSS,
  TERMS_AND_CONDITIONS,
  LOADING_TERMS_AND_CONDITIONS,
  LOADING_HEADLINE,
  HEADLINE,
  LOADING_LIST_LAYANAN,
  LIST_LAYANAN,
  LOADING_LIST_PRODUK,
  LIST_PRODUK,
  LOADING_CALL_TO_ACTION,
  CALL_TO_ACTION,
  LIST_WORD_STYLING,
  LOADING_LIST_WORD_STYLING,
  LOADING_LIST_ANNOUNCEMENT,
  LIST_ANNOUNCEMENT,
} from "@/src/application/constants/loginPage";

export function getCaptcha(payload: any): (dispatch: any) => void {
  return (dispatch) => {
    dispatch(loadingCaptcha());

    fetchGetCaptcha(payload)
      .then((res: any) => {
        dispatch(captchaContentFetched(res));
        return res;
      })
      .catch((err: any) => {
        dispatch(captchaContentFetched(err));
      });
  };
}

export function loginAction(payload: any): (dispatch: any) => void {
  return (dispatch) => {
    dispatch(loadingLogin());
    fetchDoLogin(payload)
      .then((res: any) => {
        dispatch(loginDatasFetched(res));
        if (res?.data?.user?.pernr) {
          identifyUser({
            id: res.data.user.pernr,
            username: res.data.user.sname,
          });
        }
        return res;
      })
      .catch((err: any) => {
        dispatch(loginDatasFetched(err));
      });
  };
}

export function logoutAction(token: string): (dispatch: any) => void {
  // payload: any
  // token: string
  console.log("masuk siniii logout");
  return (dispatch) => {
    clearUser();
    dispatch(loadingLogout());
    dispatch(loginDatasFetched([]));
    fetchDoLogout(token)
      .then((res: any) => {
        // dispatch(logoutDatasFetched(res));
        return res;
      })
      .catch((err: any) => {
        dispatch(loginDatasFetched(err));
      });
  };
}

export function resetLoginData(): (dispatch: any) => void {
  return (dispatch) => {
    dispatch(loginDatasFetched([]));
  };
}

export function validateTokenBSS(payload: any): (dispatch: any) => void {
  return (dispatch) => {
    dispatch(loadingValidateTokenBSS());

    fetchValidateTokenBSS(payload)
      .then((res: any) => {
        dispatch(validateTokenBSSFetched(res));
        return res;
      })
      .catch(() => {
        dispatch(validateTokenBSSFetched([]));
      });
  };
}

export function termsAndConditionsAction(
  token: string,
): (dispatch: any) => void {
  return (dispatch) => {
    dispatch(loadingTermsAndConditions());

    fetchTermsAndConditions(token)
      .then((res: any) => {
        dispatch(termsAndConditionsFetched(res));
        return res;
      })
      .catch(() => {
        dispatch(termsAndConditionsFetched([]));
      });
  };
}

export function listWordStylingAction(): (dispatch: any) => void {
  return (dispatch) => {
    dispatch(loadingWListWordStyling());

    fetchListWordStyling()
      .then((res: any) => {
        dispatch(listWordStylingFetched(res));
        return res;
      })
      .catch((err: any) => {
        dispatch(listWordStylingFetched(err));
      });
  };
}

export function headlineAction(): (dispatch: any) => void {
  return (dispatch) => {
    dispatch(loadingHeadline());

    fetchHeadline()
      .then((res: any) => {
        dispatch(headlineFetched(res));
        return res;
      })
      .catch((err: any) => {
        dispatch(headlineFetched(err));
      });
  };
}

export function listLayananAction(): (dispatch: any) => void {
  return (dispatch) => {
    dispatch(loadingListLayanan());

    fetchListServices()
      .then((res: any) => {
        dispatch(listLayananFetched(res));
        return res;
      })
      .catch((err: any) => {
        dispatch(listLayananFetched(err));
      });
  };
}

export function AnnouncementAction(): (dispatch: any) => void {
  return (dispatch) => {
    dispatch(loadingAnnouncement());

    fetchAnnouncement()
      .then((res: any) => {
        dispatch(listAnnouncementFetched(res));
        return res;
      })
      .catch((err: any) => {
        dispatch(listAnnouncementFetched(err));
      });
  };
}

export function listProdukAction(): (dispatch: any) => void {
  return (dispatch) => {
    dispatch(loadingListProduk());

    fetchListDaftarProduk()
      .then((res: any) => {
        dispatch(listProdukFetched(res));
        return res;
      })
      .catch((err: any) => {
        dispatch(listProdukFetched(err));
      });
  };
}

export function callToActionAction(): (dispatch: any) => void {
  return (dispatch) => {
    dispatch(loadingCallToAction());

    fetchCallToAction()
      .then((res: any) => {
        dispatch(callToActionFetched(res));
        return res;
      })
      .catch((err: any) => {
        dispatch(callToActionFetched(err));
      });
  };
}

function captchaContentFetched(captchaContent: any) {
  return {
    type: CAPTCHA,
    captchaContent,
  };
}

function loginDatasFetched(loginDatas: any) {
  return {
    type: LOGIN,
    loginDatas,
  };
}

function logoutDatasFetched(logoutDatas: any) {
  return {
    type: LOGOUT,
    logoutDatas,
  };
}

function validateTokenBSSFetched(validateBSSDatas: any) {
  return {
    type: VALIDATE_TOKEN_BSS,
    validateBSSDatas,
  };
}
function termsAndConditionsFetched(termsAndConditionsDatas: any) {
  return {
    type: TERMS_AND_CONDITIONS,
    termsAndConditionsDatas,
  };
}

function listWordStylingFetched(listWordStyling: any) {
  return {
    type: LIST_WORD_STYLING,
    listWordStyling,
  };
}
function headlineFetched(headline: any) {
  return {
    type: HEADLINE,
    headline,
  };
}
function listLayananFetched(listLayanan: any) {
  return {
    type: LIST_LAYANAN,
    listLayanan,
  };
}
function listAnnouncementFetched(listAnnouncement: any) {
  return {
    type: LIST_ANNOUNCEMENT,
    listAnnouncement,
  };
}
function listProdukFetched(listProduk: any) {
  return {
    type: LIST_PRODUK,
    listProduk,
  };
}
function callToActionFetched(callToAction: any) {
  return {
    type: CALL_TO_ACTION,
    callToAction,
  };
}

function loadingCaptcha() {
  return { type: LOADING_CAPTCHA };
}

function loadingLogin() {
  return { type: LOADING_LOGIN };
}

function loadingLogout() {
  return { type: LOADING_LOGOUT };
}

function loadingValidateTokenBSS() {
  return { type: LOADING_VALIDATE_TOKEN_BSS };
}

function loadingTermsAndConditions() {
  return { type: LOADING_TERMS_AND_CONDITIONS };
}

function loadingWListWordStyling() {
  return { type: LOADING_LIST_WORD_STYLING };
}

function loadingHeadline() {
  return { type: LOADING_HEADLINE };
}

function loadingListLayanan() {
  return { type: LOADING_LIST_LAYANAN };
}

function loadingAnnouncement() {
  return { type: LOADING_LIST_ANNOUNCEMENT };
}

function loadingListProduk() {
  return { type: LOADING_LIST_PRODUK };
}

function loadingCallToAction() {
  return { type: LOADING_CALL_TO_ACTION };
}
